document.addEventListener('DOMContentLoaded', () => {
  let currentModal = null;

  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  const renderPriceHTML = (variant) => {
    const price = variant.price;
    const compareAt = variant.compare_at_price;

    if (!compareAt || compareAt <= price) {
      return `
      <div class="price price--large">
        <div class="mini-price__container">
          <div class="price_group">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span class="price-item price-item--regular">${money(price)}</span>
            </div>
            <div class="price__sale"></div>
          </div>
      </div>
      </div>  
        `;
    }

    return `
      <div class="price price--large price--on-sale">
        <div class="mini-price__container">
          <div class="price_group">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span class="price-item price-item--regular">
                <s>${money(compareAt)}</s>
              </span>
            </div>
            <div class="price__sale">
              <div>
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span><s class="price-item price-item--regular">${money(compareAt)}</s></span>
              </div>
              <div>
                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                <span class="price-item price-item--sale price-item--last">
                  ${money(price)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      `;
  };

  const createModalHTML = (product) => {
    const variants = product.variants || [];
    const defaultVariant = product.selected_or_first_available_variant || variants[0] || {};
    const images = (product.images || []).map(i => typeof i === 'string' ? i : i.src)
                              .map(src => src.replace(/^\/\//, 'https://'));
    const mainImageSrc = defaultVariant.featured_image?.src
      ? defaultVariant.featured_image.src.replace(/^\/\//, 'https://')
      : images[0] || '';
    const qtyRule = defaultVariant.quantity_rule || { min: 1, increment: 1, max: null };

    return `
<div class="product-modal-overlay" id="uniqueQuickViewModal">
  <div class="product-modal product__info-container">
    <button class="close-btn-modal" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#1C1B1F"/>
      </svg>
    </button>

    <div class="product-gallery">
      <div class="main-image">
        <img id="mainProductImage" src="${mainImageSrc}" alt="${product.title}">

        <button type="button" class="nav-btn prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 20" fill="none">
            <path d="M10.0004 -1.55175e-07L11.7754 1.775L3.55039 10L11.7754 18.225L10.0004 20L0.000390927 10L10.0004 -1.55175e-07Z" fill="#1C1B1F"/>
          </svg>
        </button>

        <button type="button" class="nav-btn next">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 20" fill="none">
            <path d="M1.775 20L0 18.225L8.225 10L0 1.775L1.775 0L11.775 10L1.775 20Z" fill="#1C1B1F"/>
          </svg>
        </button>
      </div>

      <div class="thumbnails">
        ${images.map((src, i) => `
          <img src="${src}" data-index="${i}" class="${i === 0 ? 'active' : ''}" alt="Thumbnail">
        `).join('')}
      </div>
    </div>

    <div class="product-info">
      <div class="title-price">
        <h1 class="product-title">${product.title}</h1>
        <div id="price-container">
          ${renderPriceHTML(defaultVariant)}
        </div>
      </div>

      <!-- 🆕 THÊM SCRIPT JSON VARIANTS DATA -->
      <script type="application/json" data-product-variants="${product.id}">
        {
          "variants": [
            ${variants.map(v => `{
              "id": ${v.id},
              "options": ${JSON.stringify(v.options || [v.option1, v.option2, v.option3].filter(Boolean))},
              "featured_media": ${v.featured_image ? JSON.stringify({
                src: v.featured_image.src.replace(/^\/\//, 'https://')
              }) : 'null'},
              "available": ${v.available},
              "price": ${v.price},
              "compare_at_price": ${v.compare_at_price || 'null'}
            }`).join(',')}
          ]
        }
      </script>

      <!-- Swatches -->
      ${product.options.length > 1 ? product.options.map((opt, i) => `
        <div class="variant-option-swatch">
          <p class="pcm-swatch-active-text pcm-swatch-active-text-popup">
            <span class="option-name">${opt.name}:</span> 
            <span class="option-value" data-index="${i}">${defaultVariant[`option${i + 1}`] || opt.values[0]}</span>
          </p>
          <div class="pcm-swatches pcm-swatches-popup" data-index="${i}" data-product-id="${product.id}">
            ${opt.values.map((val, j) => {
              const variant = variants.find(v => v[`option${i + 1}`] === val) || defaultVariant;
              const selected = val === (defaultVariant[`option${i + 1}`] || opt.values[0]);
              const slug = val.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
              const swatchUrl = `/cdn/shop/files/${slug}.png`;
              const inputId = `swatch-${product.id}-${i}-${j}`;

              return `
                <div class="pcm-swatch-element ${!variant.available ? 'soldout' : ''} ${selected ? 'selected' : ''}">
                  <input class="pcm-swatch-input pcm-swatch-input-popup" 
                         type="radio" 
                         name="option${i + 1}-${product.id}" 
                         id="${inputId}" 
                         value="${variant.id}"
                         data-option-value="${val}"
                         data-index="${i}"
                         data-product-id="${product.id}"
                         ${selected ? 'checked' : ''} 
                         ${!variant.available ? 'disabled' : ''}>
                  <label for="${inputId}" class="pcm-swatch-label" title="${val}">
                    <div class="pcm-swatch-wrapper pcm-swatch-wrapper-popup">
                      <span class="swatch" style="background: url('${swatchUrl}'); background-size: cover; background-position: center;"></span>
                      <span class="pcm-swatch-text">${val}</span>
                    </div>
                  </label>
                </div>
                `;
            }).join('')}
          </div>
        </div>
      `).join('') : ''}

      <div class="popup_price-per-item__container">
        <quantity-input class="shop-quantity" data-url="${product.url}">
          <button class="quantity__button no-js-hidden" name="minus" type="button">
            <span class="visually-hidden">Giảm</span>
            <svg viewBox="0 0 10 2"><path d="M0 1H10" stroke="currentColor" stroke-width="2"/></svg>
          </button>
          <input class="quantity__input"
            form="popup-product-form-${product.handle}"
            type="number"
            name="quantity"
            value="${qtyRule.min}"
            min="${qtyRule.min}"
            data-cart-quantity="${qtyRule.min}"
            ${qtyRule.max ? `max="${qtyRule.max}"` : ''}
            step="${qtyRule.increment}">
          <button class="quantity__button no-js-hidden" name="plus" type="button">
            <span class="visually-hidden">Tăng</span>
            <svg viewBox="0 0 10 10"><path d="M5 0V10M0 5H10" stroke="currentColor" stroke-width="2"/></svg>
          </button>
        </quantity-input>

        <div>
          <product-form class="product-form" data-hide-errors="false">
            <div class="product-form__error-message-wrapper" role="alert" hidden>
              <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.5" r="5.5" stroke="white" stroke-width="2"></circle>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
              </svg>
              <span class="product-form__error-message"></span>
            </div>

            <form method="post" action="/cart/add" 
                  id="popup-product-form-${product.handle}"
                  accept-charset="UTF-8" 
                  class="form" 
                  enctype="multipart/form-data" 
                  novalidate="novalidate" 
                  data-type="add-to-cart-form">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="id" value="${defaultVariant.id}" class="product-variant-id">

              <button type="submit" id="set-cart" class="set-cart">
                <span class="add-btn-text">
                  ${defaultVariant.available ? "ADD" : "SOLD OUT"}
                </span>
                <div class="loading__spinner hidden">
                  <svg aria-hidden="true" class="spinner" viewBox="0 0 66 66">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>

              <input type="hidden" name="product-id" value="${product.id}">
              <input type="hidden" name="section-id" value="template--19321097584806__main">
            </form>
          </product-form>
        </div>
      </div>

      <div class="popup-description">
        ${cleanDescription(product.description, true)}
      </div>
    </div>
  </div>
</div>`;
  };
  
  function cleanDescription(str, toHTML = true) {
    if (!str) return "";

    let cleaned = str
      .trim()
      .replace(/\r/g, "")
      .replace(/[ \t]+/g, " ")
      .replace(/\n{2,}/g, "\n");

    if (!toHTML) return cleaned;

    let shortText = cleaned.substring(0, 676);
    if (cleaned.length > 676) shortText += "...";

    const shortHTML = shortText.split("\n").map(line => `<p>${line.trim()}</p>`).join("");
    const fullHTML = cleaned.split("\n").map(line => `<p>${line.trim()}</p>`).join("");

    return `
      <div class="desc-short active">${shortHTML}</div>
      <div class="desc-full">${fullHTML}</div>
      <button type="button" class="desc-readmore">Read more</button>
    `;
  }

  function changeModalImage(mainImg, wrapper, newSrc) {
    let oldSpinner = wrapper.querySelector('.modal-spinner');
    if (oldSpinner) oldSpinner.remove();

    mainImg.classList.add('modal-img-loading');

    const spinnerHTML = `
      <div class="modal-spinner">
        <svg aria-hidden="true" focusable="false" width="20" height="20" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
    wrapper.insertAdjacentHTML('beforeend', spinnerHTML);

    mainImg.src = newSrc;

    mainImg.onload = () => {
      let sp = wrapper.querySelector('.modal-spinner');
      if (sp) sp.remove();
      mainImg.classList.remove('modal-img-loading');
    };
  }

  const initModal = (modal) => {
    document.body.style.overflow = 'hidden';

    const mainImg = modal.querySelector('#mainProductImage');
    const thumbs = modal.querySelectorAll('.thumbnails img');
    const prevBtn = modal.querySelector('.nav-btn.prev');
    const nextBtn = modal.querySelector('.nav-btn.next');
    const closeBtn = modal.querySelector('.close-btn-modal');
    const quantityInput = modal.querySelector('.quantity input');
    const priceContainer = modal.querySelector('#price-container');
    const btnReadMore = modal.querySelector('.desc-readmore');
    const shortBox = modal.querySelector('.desc-short');
    const fullBox = modal.querySelector('.desc-full');

    let currentIndex = 0;

    const close = () => {
      modal.remove();
      currentModal = null;
      document.body.style.overflow = '';
    };
    
    closeBtn.onclick = e => { e.stopPropagation(); close(); };
    modal.onclick = e => { if (e.target === modal) close(); };

    if (btnReadMore) {
      btnReadMore.onclick = () => {
        const isOpen = fullBox.style.display === "block";
        if (isOpen) {
          fullBox.style.display = "none";
          shortBox.style.display = "block";
          btnReadMore.textContent = "Read more";
        } else {
          fullBox.style.display = "block";
          shortBox.style.display = "none";
          btnReadMore.textContent = "Read less";
        }
      };
    }

    // 🆕 LOGIC SWATCH GIỐNG CHANGE-SWATCH-INPUT.JS
    modal.querySelectorAll('.pcm-swatch-input-popup').forEach(function(input) {
      input.addEventListener('change', function() {
        const productId = this.getAttribute('data-product-id');
        
        // Lấy tất cả các option đã chọn
        const swatchGroups = modal.querySelectorAll(`.pcm-swatches-popup`);
        const selectedOptions = [];
        
        swatchGroups.forEach(function(swatchGroup) {
          const groupProductId = swatchGroup.getAttribute('data-product-id');
          
          if (groupProductId === productId) {
            const index = swatchGroup.getAttribute('data-index');
            const checkedInput = swatchGroup.querySelector('.pcm-swatch-input-popup:checked');
            const optionValue = checkedInput ? checkedInput.getAttribute('data-option-value') : null;
            selectedOptions[index] = optionValue;
          }
        });

        // Lấy variant data từ JSON
        const variantDataElement = modal.querySelector(`[data-product-variants="${productId}"]`);
        
        if (!variantDataElement) return;

        let variantsData;
        try {
          variantsData = JSON.parse(variantDataElement.textContent);
        } catch(e) {
          console.error('❌ Lỗi parse JSON:', e);
          return;
        }

        // Tìm variant khớp
        const matchedVariant = variantsData.variants.find(function(variant) {
          return variant.options.every(function(option, index) {
            return option === selectedOptions[index];
          });
        });

        if (!matchedVariant) return;
        console.log(matchedVariant)
        // Cập nhật hidden input
        const form = modal.querySelector('form[id^="popup-product-form-"]');
        const hiddenInput = form ? form.querySelector('.product-variant-id') : null;


        if (hiddenInput && form) {
          console.log('📋 Form:', form.id);
          console.log('📋 Before update:', hiddenInput.value);
          hiddenInput.setAttribute('value', matchedVariant.id);
          hiddenInput.value = matchedVariant.id;
          
        }

        // Cập nhật price
        priceContainer.innerHTML = renderPriceHTML(matchedVariant);

        // Cập nhật ảnh
        if (matchedVariant.featured_media && matchedVariant.featured_media.src) {
          const newImageSrc = matchedVariant.featured_media.src;
          changeModalImage(mainImg, mainImg.parentElement, newImageSrc);
          
          // Cập nhật thumbnail active
          const matchingThumb = Array.from(thumbs).find(t => t.src === newImageSrc);
          if (matchingThumb) {
            currentIndex = parseInt(matchingThumb.dataset.index);
            thumbs.forEach(t => t.classList.remove('active'));
            matchingThumb.classList.add('active');
          }
        }

        // Cập nhật text option
        const optionIndex = this.getAttribute('data-index');
        const optionValueSpan = modal.querySelector(`.option-value[data-index="${optionIndex}"]`);
        if (optionValueSpan) {
          optionValueSpan.textContent = this.getAttribute('data-option-value');
        }
      });
    });

    // Dots navigation
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'thumbnails-dots';

    thumbs.forEach((thumb, i) => {
      const dot = document.createElement('span');
      dot.className = i === 0 ? 'dot active' : 'dot';
      dot.dataset.index = i;

      dot.onclick = () => {
        currentIndex = i;
        changeModalImage(mainImg, mainImg.parentElement, thumb.src);

        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        dotsContainer.querySelectorAll('.dot').forEach(d => d.classList.remove('active'));
        dot.classList.add('active');

        thumb.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      };

      dotsContainer.appendChild(dot);
    });

    modal.querySelector('.product-gallery').appendChild(dotsContainer);

    // Thumbnail click
    thumbs.forEach((thumb, i) => {
      thumb.onclick = () => {
        currentIndex = i;
        changeModalImage(mainImg, mainImg.parentElement, thumb.src);
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        dotsContainer.querySelectorAll('.dot').forEach((d, idx) => {
          d.classList.toggle('active', idx === i);
        });
      };
    });

    // Prev / Next
    prevBtn.onclick = () => {
      currentIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
      thumbs[currentIndex].click();
    };
    nextBtn.onclick = () => {
      currentIndex = (currentIndex + 1) % thumbs.length;
      thumbs[currentIndex].click();
    };

    // Quantity
    modal.querySelectorAll('.quantity button').forEach(btn => {
      btn.onclick = () => {
        let val = parseInt(quantityInput.value) || 1;
        val = btn.textContent === '+' ? val + 1 : (val > 1 ? val - 1 : 1);
        quantityInput.value = val;
      };
    });

    // Close modal on cart update
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      close();
    });
  };

  const openModal = async (handle) => {
    if (currentModal) {
      currentModal.remove();
      currentModal = null;
    }

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      const temp = document.createElement('div');
      temp.innerHTML = createModalHTML(product);
      const modal = temp.firstElementChild;

      document.body.appendChild(modal);
      currentModal = modal;
      initModal(modal);
    } catch (err) {
      console.error('Lỗi modal:', err);
    }
  };

  document.querySelectorAll('.btn-view-details').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const { handle } = btn.dataset;
      if (handle) openModal(handle);
    });
  });
});